/**
 * Shared DAR quick-phrase presets + template helpers.
 *
 * A phrase can either be plain text ("Perimeter secure.") or a template with
 * `{name}` placeholders ("Perimeter walk of {site} completed at {time}.")
 * When a template chip is tapped, the guard is prompted to fill each slot
 * before the resolved sentence is appended to the DAR narrative.
 */
export const DAR_QUICK_PHRASES = [
  "Nothing to report — nothing out of the ordinary occurred during my shift.",
  "Handover — shift handover completed with next officer. Site turned over in normal working condition.",
  "Filed IR — filed an incident report for {incident_type} — see IR # {ir_ref} for full details.",
  "Filed MR — filed a maintenance request for {issue} at {location} — see MR # {mr_ref} for full details.",
  "Officer completed all scheduled scans on time. Nothing out of the ordinary occurred during the shift.",
  "Perimeter walk completed. All entry points secure. No visitor or vehicle activity to report.",
  "Vehicle sweep completed — {count} vehicle(s) on premises, all authorised.",
];

const PLACEHOLDER_RE = /\{([a-z0-9_-]+)\}/gi;

/** Extract the list of {slot} names in template order, deduped. */
export function extractPlaceholders(str) {
  if (!str) return [];
  const seen = new Set();
  const out = [];
  let m;
  PLACEHOLDER_RE.lastIndex = 0;
  while ((m = PLACEHOLDER_RE.exec(str)) !== null) {
    const key = m[1].toLowerCase();
    if (!seen.has(key)) { seen.add(key); out.push(key); }
  }
  return out;
}

/**
 * Substitute {slots} using `values` map — case-insensitive keys, missing
 * slots are left as `{slot}` so guards can spot un-filled fields.
 */
export function applyPlaceholders(str, values) {
  if (!str) return "";
  return str.replace(PLACEHOLDER_RE, (_full, name) => {
    const v = values?.[name.toLowerCase()];
    return v == null || v === "" ? `{${name}}` : String(v);
  });
}

/** Append a phrase to existing narrative text — idempotent, blank-line join. */
export function appendPhrase(current, phrase) {
  const c = (current || "").trimEnd();
  if (!c) return phrase;
  if (c.includes(phrase)) return c;
  return `${c}\n\n${phrase}`;
}

/** Prettify a slot key for the fill-modal label (`next_officer` → `Next officer`). */
export function slotLabel(name) {
  return String(name)
    .replace(/[-_]/g, " ")
    .replace(/^./, (s) => s.toUpperCase());
}
